<template>
    <b-card no-body>
        <div class="row p-2 align-items-end">
            <div class="col-md-4 mb-1">
                <label class="form-label">Gün</label>
                <v-select-list :options="days" v-model="day" placeholder="Gün" ></v-select-list>
            </div>
            <div class="col-md-2 mb-1">
                <v-executer :loading="filterLoading" :action="getInvoices">Filtrele</v-executer>
            </div>
            <div class="6">
                <p>Vade tarihi {{ afterFilterDay }} gün geçmiş faturaları görüntülüyorsunuz.</p>
            </div>
        </div>
        
     <table class="table">
        <thead>
            <tr>
                <th class="text no-wrap w-10">Cari Kod</th>
                <th class="text no-wrap w-25">Cari Adı</th>
                <th class="text no-wrap w-20">Fatura No</th>
                <th class="text no-wrap w-15">Tarih</th>
                <th class="text no-wrap w-15">Vade Tarihi</th>
                <th class="text no-wrap w-15">Tutar</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(invoice,index) in invoices">
                <td>{{ invoice.CustomerCode }}</td>
                <td>{{ invoice.CustomerName }}</td>
                <td>{{ invoice.InvoiceNo }}</td>
                <td>{{ invoice.Date }}</td>
                <td>{{ invoice.VadeTarihi }}</td>
                <td>{{ invoice.TotalAmount }}</td>
            </tr>
        </tbody>
     </table>
    </b-card>
      
</template>
<script>
import { NetsisApi } from '@/api/netsis'
import  {ReportApi} from '@/api/report'
import { BCard } from 'bootstrap-vue'

export default {
    components:{
        BCard
    },
    data(){
        return{
            
            invoices:[],
            filterLoading:false,
            day:1,
            afterFilterDay:0,
            days:[]
        }
    },
    mounted(){
        this.getDays()
        this.getInvoices()
    },
    methods:{
        getInvoices(){
            this.filterLoading = true
           
            ReportApi.VadeTarhiXGunGecmisFaturalar(this.day).then(res => {
                this.filterLoading = false
                this.afterFilterDay = this.day
                this.invoices = res.data.Data
            }).catch(err=>{
                this.filterLoading = false
            })
        },
        getDays(){
            for (let index = 1; index <= 60; index++) {
                this.days.push(index)
                
            }
        }

    }


}


</script>